import type React from 'react';

interface GlyphProps {
  size: number;
}

// Apple's logo mark, drawn in the button's text colour as Apple's guidelines ask.
export const AppleGlyph: React.FC<GlyphProps> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
    <path d="M17.05 12.04c-.03-2.85 2.33-4.22 2.44-4.29-1.33-1.94-3.4-2.2-4.13-2.23-1.76-.18-3.43 1.03-4.32 1.03-.89 0-2.27-1.01-3.73-.98-1.92.03-3.69 1.11-4.68 2.82-2 3.47-.51 8.6 1.43 11.42.95 1.38 2.08 2.93 3.55 2.88 1.43-.06 1.97-.93 3.7-.93 1.71 0 2.21.93 3.71.9 1.54-.03 2.51-1.4 3.45-2.79 1.09-1.6 1.54-3.15 1.56-3.23-.03-.01-2.99-1.15-3.02-4.56zM14.34 4.05c.79-.96 1.32-2.29 1.18-3.62-1.14.05-2.52.76-3.34 1.72-.73.85-1.37 2.21-1.2 3.51 1.27.1 2.57-.65 3.36-1.61z" />
  </svg>
);

// Google's multicolour "G", in Google's brand colours.
export const GoogleGlyph: React.FC<GlyphProps> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      d="M21.6 12.23c0-.74-.07-1.45-.19-2.13H12v4.03h5.38c-.23 1.25-.94 2.31-2 3.02v2.5h3.23c1.89-1.74 2.99-4.31 2.99-7.42z"
      fill="#4285F4"
    />
    <path
      d="M12 22c2.7 0 4.97-.9 6.62-2.43l-3.23-2.5c-.9.6-2.04.96-3.39.96-2.61 0-4.82-1.76-5.61-4.13H3.06v2.58C4.7 19.74 8.07 22 12 22z"
      fill="#34A853"
    />
    <path
      d="M6.39 13.9c-.2-.6-.31-1.24-.31-1.9s.11-1.3.31-1.9V7.52H3.06A9.996 9.996 0 0 0 2 12c0 1.61.39 3.14 1.06 4.48l3.33-2.58z"
      fill="#FBBC05"
    />
    <path
      d="M12 5.97c1.47 0 2.79.51 3.83 1.5l2.87-2.87C16.96 2.99 14.7 2 12 2 8.07 2 4.7 4.26 3.06 7.52L6.39 10.1C7.18 7.73 9.39 5.97 12 5.97z"
      fill="#EA4335"
    />
  </svg>
);

// A generic outline envelope; email has no brand mark.
export const EmailGlyph: React.FC<GlyphProps> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
    <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M4 7l8 6 8-6" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
  </svg>
);

// Microsoft's four-square logo, in Microsoft's brand colours.
export const MicrosoftGlyph: React.FC<GlyphProps> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <rect x="2" y="2" width="9.5" height="9.5" fill="#F25022" />
    <rect x="12.5" y="2" width="9.5" height="9.5" fill="#7FBA00" />
    <rect x="2" y="12.5" width="9.5" height="9.5" fill="#00A4EF" />
    <rect x="12.5" y="12.5" width="9.5" height="9.5" fill="#FFB900" />
  </svg>
);
